export class TimeoutError extends Error {
  constructor(message) {
    super(message);
    this.name = "TimeoutError";
  }
}

export class AlignError extends Error {
  constructor(message, isUnauthorizedError) {
    super(message);
    this.name = "AlignError";
    this.isUnauthorizedError = isUnauthorizedError;
  }
}
